export default "__VITE_ASSET__c7Xw7nlm__"